export default "__VITE_ASSET__371fb316__"